import React from "react";
import styles from "./styles/ChannelPartner.module.css";
import Header from "../../shared/Header/Header";
import Footer from "../../shared/Footer/Footer";
import ChannelPartnerHero from "./ChannelPartnerHero";
import ChannelPartnerProducts from "./ChannelPartnerProducts";
import ChannelPartnerCTA from "./ChannelPartnerCTA";

export default function ChannelPartner() {
  return (
    <div className={styles.page}>
      <Header />
      <main>
        <ChannelPartnerHero />
        <ChannelPartnerProducts />
        <ChannelPartnerCTA />
      </main>
      <Footer />
    </div>
  );
}
